<template>
    <div class="container" :class="{english:$i18n.locale=='en'}">
        <headLine index="1" ref="dialog" showbar="true" @on-locale-change="onLocaleChange">
        </headLine>
        <div class="dialog_masker" style="height:100%;z-index:214748364778!important" v-show="show_game_dialog" @click.self="show_game_dialog=false;" @touchmove.prevent>
            <div class="middle game_dailog" style="width:6.5rem;height:10.5rem;position: relative;">
                <span class="close_game_dialog" @click="show_game_dialog=false"></span>
                <img :src="imglist[21]" style="width:6.5rem;height:10.5rem;position: absolute;left:0;top:0;border-radius:5px;" v-if="$i18n.locale=='ch'">
                <img :src="imglist[22]" style="width:6.5rem;height:10.5rem;position: absolute;left:0;top:0;border-radius:5px;" v-if="$i18n.locale=='en'">
            </div>
        </div>
        <div class="banner banner1">

            <img :src="imglist[0]" alt="">
            <h1 class="banner_title" v-html="$t('home.index.banner_title')">
            </h1>
            <h1 class="banner_title banner_title1" v-html="$t('home.index.banner_text')">
            </h1>
            <div class="center button_banner" style="position:absolute;top:48%;width:100%">
                <router-link to="/product"><a class="button_default" v-html="$t('home.download')"></a></router-link>
                <h2 style="font-size:0.28rem;color:#fff;margin-top:30%" v-html="$t('home.index.vrviu')"></h2>
                <span class="guaid_arrow"></span>
            </div>
        </div>
<!--         <div class="center notice" v-html="$t('home.index.notice')">
        </div> -->
        <div class="content center">
            <div class="content_item">
                <h3 class="content_item_title" v-html="$t('home.index.title1')">
                </h3>
                <div class="center">
                    <img v-lazy="imglist[1]" alt="" style="width:100%;height:9.45rem;width:5.18rem;margin:0.4rem auto 0 auto" v-if="$i18n.locale=='ch'">
                    <img v-lazy="imglist[10]" alt="" style="width:100%;height:9.45rem;width:5.18rem;margin:0.4rem auto 0 auto" v-if="$i18n.locale=='en'">
                </div>
                <div class="center" style="background:#f4f9ff;margin-top:0.7rem">
                    <ul class="bar_list clearfix">
                        <li>
                            <router-link to="/technology">
                                <span class="bar_icon"></span>
                                <div class="bar_tex" v-html="$t('home.index.item_title1')">
                                </div>
                                <div class="bar_item">
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/technology">
                                <span class="bar_icon bar_icon1"></span>
                                <div class="bar_tex" v-html="$t('home.index.item_title2')">
                                </div>
                                <div class="bar_item bar_item2">
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/technology">
                                <span class="bar_icon bar_icon2"></span>
                                <div class="bar_tex" v-html="$t('home.index.item_title3')">
                                </div>
                                <div class="bar_item bar_item1">
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/technology">
                                <span class="bar_icon bar_icon3"></span>
                                <div class="bar_tex" v-html="$t('home.index.item_title4')">
                                </div>
                                <div class="bar_item bar_item2 bar_item1">
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="content_item">
                    <h3 class="content_item_title" v-html="$t('home.index.title2')">
                    </h3>
                    <p class="center support_model"><span :class='{"active_tab":showTab==1}' style="margin-right:30px;" @mouseover="showTab=1">VR</span><span @mouseover="showTab=2" :class='{"active_tab":showTab==2}'>2D</span></p>
                    </p>
                    <div class="pictures">
                        <ul v-if="showTab==1">
                            <li class="pic_content">
                                <div class="pic_item">
                                    <router-link to="/solution1">
                                        <img v-lazy="imglist[2]" alt="">
                                        <div class="middle" v-html="$t('home.index.pic_text1')">
                                        </div>
                                    </router-link>
                                </div>
                            </li>
                            <li class="pic_content pic_content1 clearfix">
                                <div class="fl">
                                    <div class="pic_item">
                                        <router-link to="/solution">
                                            <img v-lazy="imglist[3]" alt="">
                                            <div class="middle" v-html="$t('home.index.pic_text2')">
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="fr">
                                    <div class="pic_item pic_item2">
                                        <router-link to="/solution">
                                            <img v-lazy="imglist[4]" alt="">
                                            <div class="middle" v-html="$t('home.index.pic_text3')">
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </li>
                            <li class="pic_content pic_content1 clearfix">
                                <div class="fl">
                                    <div class="pic_item">
                                        <router-link to="/solution">
                                            <img v-lazy="imglist[5]" alt="">
                                            <div class="middle" v-html="$t('home.index.pic_text4')">
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="fr">
                                    <div class="pic_item pic_item2">
                                        <router-link to="/solution">
                                            <img v-lazy="imglist[6]" alt="">
                                            <div class="middle" v-html="$t('home.index.pic_text5')">
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul v-if="showTab==2">
                            <li class="pic_content">
                                <div class="pic_item">
                                    <router-link to="/solution2">
                                        <img v-lazy="imglist[11]" alt="">
                                        <div class="middle" v-html="$t('home.text4')">
                                        </div>
                                    </router-link>
                                </div>
                            </li>
                            <li class="pic_content">
                                <div class="pic_item">
                                    <router-link to="/solution2">
                                        <img v-lazy="imglist[12]" alt="">
                                        <div class="middle" v-html="$t('home.text5')">
                                        </div>
                                    </router-link>
                                </div>
                            </li>
                            <li class="pic_content">
                                <div class="pic_item">
                                    <router-link to="/solution2">
                                        <img v-lazy="imglist[13]" alt="">
                                        <div class="middle" v-html="$t('home.text6')">
                                        </div>
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content_item" style="background:#f4f9ff;height:5.5rem;position:relative">
                    <h3 class="content_item_title" v-html="$t('home.index.title3')">
                    </h3>
                    <div style="margin-top:0.4rem;margin:0.4rem 0.32rem 0 0.32rem;">
                        <!--             <img  alt="" v-lazy="imglist[9]" style="height:5rem;width:6.86rem;position:absolute;z-index:1000;top:1rem"> -->
                        <my-video :sources="video.sources" :options="video.options" ref="video"></my-video>
                        <span class="playBtn" @click="play_video()" v-show="show_play_btn"></span>
                    </div>
                </div>
                <div class="content_item" style="margin-bottom:-0.36rem">
                    <h3 class="content_item_title" v-html="$t('home.index.try_download')">
                    </h3>
                    <img v-lazy="imglist[7]" alt="" style="width:4.05rem;height:3.69rem;margin:0.4rem auto 0.1rem auto">
                    <div class="center">
                        <router-link to="/software"><a class="button_default button_default2" v-html="$t('home.index.try_download_btn')"></a></router-link>
                    </div>
                    <h3 class="content_item_title" v-html="$t('home.index.friends')" style="margin-top:1.4rem">
                    </h3>
                    <div class="center friendsList clearfix">
                        <img v-lazy="imglist[14]" alt="" style="width:2.7rem;height:1rem">
                        <img v-lazy="imglist[15]" alt="" style="width:2.7rem;height:1rem">
                        <img v-lazy="imglist[16]" alt="" style="width:2.7rem;height:1rem">
                        <img v-lazy="imglist[17]" alt="" style="width:2.7rem;height:1rem">
                        <img v-lazy="imglist[18]" alt="" style="width:2.7rem;height:1rem">
                        <img v-lazy="imglist[19]" alt="" style="width:2.7rem;height:1rem">
                        <img v-lazy="imglist[20]" alt="" style="width:2.7rem;height:1rem">
                    </div>
                    <div class="content_bg" v-lazy:background-image="imglist[8]">
                        <div class="content_footer">
                            <h3 class="content_item_title white" style="magin-bottom:0.4rem" v-html="$t('home.index.try_free')">
                            </h3>
                            <h2 class="content_item_text content_item_text1 white" v-html="$t('home.index.try_free_text')"></h2>
                            <h2 class="content_item_text white" v-html="$t('home.index.try_free_text2')"></h2>
                            <router-link to="/product" class="button_default" style="margin-top:0.7rem" v-html="$t('home.index.try_free_btn')"></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footerLine></footerLine>
    </div>
</template>
<script>
import headLine from "./header"
import footerLine from "./footer"
import myVideo from 'vue-video';
import Vue from 'vue'
import i18n from '../common/i18n'


export default {
    name: 'index',
    i18n: i18n,
    data() {
        return {
            show_game_dialog: true,
            imglist: [
                "/static/images/banner/banner.png",
                "/static/images/img1.png",
                "/static/images/img2.png",
                "/static/images/img3.png",
                "/static/images/img4.png",
                "/static/images/img5.png",
                "/static/images/img6.png",
                "/static/images/img8.png",
                "/static/images/img9.png",
                "/static/images/img7.png",
                "/static/images/image11.png",
                "/static/images/img2d1 (1).png",
                "/static/images/img2d1 (2).png",
                "/static/images/img2d1 (3).png",
                "/static/images/logo11.png",
                "/static/images/logo12.png",
                "/static/images/logo13.png",
                "/static/images/logo14.png",
                "/static/images/logo15.png",
                "/static/images/logo16.png",
                "/static/images/logo17.png",
                "/static/images/dialog.jpg",
                "/static/images/dialog_en.jpg"

            ],
            showTab: 1,
            show_play_btn: true,
            video: {
                sources: [{
                    src: '/static/media/BG_loop.mp4',
                    type: 'video/mp4'
                }],
                options: {
                    autoplay: false,
                    volume: 0.6,
                    poster: '/static/images/img7.png'
                }
            },
        }
    },
    watch: {

    },

    created() {
        var language = navigator.language; //取得浏览器版本语言
        var initLanguage = "";
        if (localStorage.locale) {
            this.$i18n.locale = localStorage.locale;
        } else {
            if (language.indexOf('zh') > -1) {
                initLanguage = "ch"; //中文页面
            } else if (language.indexOf('en') > -1) {
                initLanguage = "en"; //英文页面
            }
            this.$i18n.locale = initLanguage;
        }
        if (this.$i18n.locale == "ch") {
            this.video.options.poster = "/static/media/bg.jpg"
        } else {
            this.video.options.poster = "/static/static/media/VRVIU4Mbps2.png"
        }
    },
    methods: {
        play_video() {
            setTimeout(() => {
                this.$refs.video.fullScreen();
            })
            this.$refs.video.$video
                .addEventListener('ended', (e) => {
                    this.show_play_btn = true;
                }, false)
            this.$refs.video.play();
            this.show_play_btn = false;
        },
        showDialog() {
            this.$refs.dialog.showDialog = true;
            this.$refs.dialog.showNext = false;
            if (this.$i18n.locale == "en") {
                this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";

            } else {
                this.$refs.dialog.content_type2 = "申请使用威尔云";

            }
        },
        onLocaleChange: function(val) {
            this.$i18n.locale = val;
            if (this.$i18n.locale == "ch") {
                this.video.options.poster = "/static/media/bg.jpg"
            } else {
                this.video.options.poster = "/static/media/VRVIU4Mbps2.png"
            }
        }
    },
    components: {
        headLine,
        myVideo,
        footerLine
    }
}
</script>
<style scoped>
.close_game_dialog {
    display: inline-block;
    width: 0.4rem;
    height: 0.4rem;
    background: url(../assets/images/Close@2x.png) center bottom no-repeat;
    background-size: cover;
    position: absolute;
    right: 0.4rem;
    top: 0.4rem;
    z-index: 3;
    cursor: pointer;

}

.support_model {
    font-size: 0.3rem;
    color: #282828;
    margin-top: 0.4rem;
}

.friendsList {
    margin-bottom: -1rem
}

.friendsList img {
    display: inline-block !important;
}

.support_model span {
    display: inline-block;
    width: 0.8rem;
    padding-bottom: 0.22rem;
    margin-bottom: 0.3rem;
    cursor: pointer;
}

.support_model span.active_tab {
    color: #0986ff;
    border-bottom: 2px solid #0986ff;
}

.playBtn {
    display: inline-block;
    width: 0.8rem;
    height: 0.8rem;
    background: url(../assets/images/playBtn.png) no-repeat;
    background-size: cover;
    position: absolute;
    top: 3rem;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 2000;
}

.dialog_masker {
    width: 100%;
    position: fixed;
    left: 0;
    z-index: 10000;
    background: rgba(0, 0, 0, 0.6)
}

@media screen and (orientation: landscape) {
    .banner_title1 {
        top: 48% !important
    }

    .button_banner {
        top: 63% !important
    }
}

.english .button_banner h2 {
    /*margin-top:3.2rem!important;*/
}

.banner {
    height: 100% !important
}

.english .banner_title {
    font-size: 0.6rem;
}

.banner_title {
    top: 30%;
    font-size: 0.54rem;
}

.banner_title1 {
    top: 38%
}

.english .banner_title1 {
    top: 37%
}

.guaid_arrow {
    display: inline-block;
    height: 0.19rem;
    width: 0.34rem;
    background: url(../assets/images/banner/banner_icon_down.png) no-repeat;
    background-size: cover;
    margin-top: 0.4rem;
}

.english .notice {
    font-size: 0.22rem;
}

.notice {
    height: 0.9rem;
    line-height: 0.9rem;
    color: #282828;
    font-size: 0.24rem;
    border-bottom: 1px solid #E5E5E5;
}

.pic_item img {
    margin-top: 0;
    width: 100%;
    height: 100%;

}

.pic_item .middle {
    width: 100%;
}

.pic_content1 .fl,
.pic_content1 .fr {
    width: 50%
}

.pic_content .pic_item {
    margin-bottom: 0.06rem;
    position: relative;
    height: 2.5rem
}

.pictures {
    margin-left: 0.32rem;
    margin-right: 0.32rem;
    margin-bottom: 0.63rem;
}

.pic_content1 .pic_item {
    margin-right: 0.03rem;
}

.pic_content1 .pic_item2 {
    margin-left: 0.03rem;
    margin-right: 0;
}

.__cov-video-container {
    border-radius: 0.04rem !important;

}

.content_bg {
    height: 7.54rem;
    width: 7.5rem;
    background-size: cover;
    position: relative;
}

.content_footer {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    bottom: 1.2rem;
}

.english .content_footer {
    /*bottom: 0.7rem;*/

}

.english .content_footer .button_default {
    margin-top: 0.2rem !important;
}
</style>


// WEBPACK FOOTER //
// index.vue?7d8c4854